/* eslint-disable no-unused-vars */
import Highway from "@dogstudio/highway";
import anime from "animejs/lib/anime.es.js";
import common from "../routes/common";

// To create your custom transition you need to provide two required methods:
// - `in`: The transition part to show your view.
// - `out`: The transition part to hide you view.
//
// Each method receives a callback method called `done` you will always have to
// call when the a transition is over.
class Fade extends Highway.Transition {
  in({ from, to, trigger, done }) {
    window.scrollTo(0, 0);
    from.remove();

    anime({
      targets: to,
      opacity: [0, 1],
      duration: 500,
      easing: "linear",
      complete: function(anim) {
        done();
        common.reInit();
        // common.finalize();
      },
    });
  }

  out({ from, to, trigger, done }) {
    // // eslint-disable-line no-unused-vars
    anime({
      targets: from,
      opacity: [1, 0],
      duration: 500,
      easing: "linear",
      complete: function(anim) {
        done();
      },
    });
  }
}

// Don't forget to export in some way your custom transition.
export default Fade;



// WEBPACK FOOTER //
// ./scripts/transitions/fade.js